const authnType = {
  //
  SET_AUTHN_STATE: "SET_AUTHN_STATE",
};

export default authnType;
